import { render, staticRenderFns } from "./AfterSurveyQuestion.vue?vue&type=template&id=4b40ded1"
import script from "./AfterSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./AfterSurveyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports